var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptionOfPack"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.LoadingReport.Packing_Information'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Carton_Seal')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaCartonseal,"otherData":{
          mediaName: '外箱封装方式',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaCartonseal',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Front_Mark')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaFrontmark,"otherData":{
          mediaName: '外箱正唛',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaFrontmark',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Side_Mark')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaSidemark,"otherData":{
          mediaName: '外箱侧唛',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaSidemark',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Carton_barcode')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaCartonbarcode,"otherData":{
          mediaName: '外箱条码',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaCartonbarcode',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Carton_Size')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaCartonsize,"otherData":{
          mediaName: '外箱尺寸',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaCartonsize',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Carton_Weight_Gross')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaCartonweight,"otherData":{
          mediaName: '外箱重量（带产品）',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaCartonweight',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Inner_Packing')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaInnerpack,"otherData":{
          mediaName: '开箱后包装',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaInnerpack',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Corrugated_Layer')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaCartonlayer,"otherData":{
          mediaName: '外箱瓦楞质量',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaCartonlayer',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Inner_box')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaInnerbox,"otherData":{
          mediaName: '内盒',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaInnerbox',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Packing_Details_Single_unit')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaPackdetail,"otherData":{
          mediaName: '单件产品包装方式',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaPackdetail',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Others_Accessory_Manual_Polybag')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.lmediaOther,"otherData":{
          mediaName: '其他',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaOther',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-table"},[_c('a-table',{staticClass:"desOfGoods-table1",attrs:{"columns":_vm.columns,"dataSource":[_vm.supervisionDetails],"bordered":"","pagination":false,"rowKey":"id"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }